import { MAX_ITEM_TYPE_ROWS } from "../../constants";
import { useAppTheme } from "../../useAppTheme";
import { useDevice } from "../../useDevice";
import Box from "../Box";
import { FlatCard } from "../Cards/FlatCard";
import { Skeleton } from "../Skeleton";

const ROW_SLOTS = Array.from({ length: MAX_ITEM_TYPE_ROWS }, (_, index) => {
	return `row-${index}`;
});

export const SessionReportCardSkeleton = () => {
	const theme = useAppTheme();
	const { isMobile } = useDevice();

	return (
		<FlatCard style={isMobile ? { borderRadius: 0 } : undefined}>
			<Box
				flexDirection="row"
				alignItems="center"
				gap={12}
				padding={16}
				borderBottomWidth={1}
				borderBottomColor={theme.colors.surfaceVariant}
			>
				<Skeleton variant="circle" size={44} />
				<Box flex={1} gap={8} minWidth={0}>
					<Skeleton height={18} width="70%" />
					<Skeleton height={14} width="50%" />
				</Box>
			</Box>
			<Box gap={0} paddingHorizontal={16}>
				{ROW_SLOTS.map((slotId, index) => (
					<Box
						key={slotId}
						flexDirection="row"
						alignItems="center"
						gap={8}
						paddingVertical={16}
						borderBottomWidth={index < ROW_SLOTS.length - 1 ? 1 : 0}
						borderBottomColor={theme.colors.surfaceVariant}
					>
						<Skeleton variant="circle" size={32} />
						<Box flex={1} gap={6} minWidth={0}>
							<Skeleton height={16} width="80%" />
							<Skeleton height={14} width="40%" />
						</Box>
						<Skeleton
							height={24}
							width={72}
							borderRadius={theme.roundness * 4}
						/>
					</Box>
				))}
			</Box>
			<Box
				width="100%"
				alignItems="flex-end"
				paddingTop={4}
				paddingHorizontal={16}
				paddingBottom={16}
			>
				<Skeleton height={36} width={88} borderRadius={theme.roundness * 4} />
			</Box>
		</FlatCard>
	);
};
